exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panel-title{height:70px\n}\n.panel-content{height:calc(100vh - 244px);overflow-y:scroll\n}\n.panel-title-divider{margin-top:1px\n}\n.panel-loader.v-progress-linear{margin:0\n}\n.panel-slot-actions .v-icon{cursor:pointer;font-size:28px!important;margin-left:8px;margin-right:8px\n}", ""]);

// exports
